<template>
  <li class="nav-item nav-search">

    <!-- Icon -->
    <a
      href="javascript:void(0)"
      class="nav-link nav-link-search"
      @click="showSearchBar = true"
    >
      <feather-icon
        icon="SearchIcon"
        size="21"
      />
    </a>

    <!-- Input -->
    <div
      class="search-input"
      :class="{'open': showSearchBar}"
    >
      <!-- <input type="text" placeholder="Explore Vuexy...." class="form-control-input"> -->
      <!-- @keyup.esc="escPressed" -->
      <!-- @keyup.enter="suggestionSelected" -->
      <b-form-input
        v-if="showSearchBar"
        id="searchinput"
        v-model="searchQuery"
        placeholder="Explore Debt Case, Debtor, Creditors"
        autofocus
        autocomplete="off"
        @keyup.up="increaseIndex(false)"
        @keyup.down="increaseIndex(true)"
        @keyup.esc="showSearchBar = false; resetsearchQuery()"
        @keyup.enter="suggestionSelected(currentSuggestion)"
        @blur.stop="showSearchBar = false; resetsearchQuery()"
      />
      <div
        class="search-input-close btn-group"
      >
        <b-button-group
          size="sm"
          class="btn-groups"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            @click="showSearchBar = false; resetsearchQuery()"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </b-button-group>
      </div>

      <!-- Suggestions List -->
      <vue-perfect-scrollbar
        id="listing-ul"
        :settings="60"
        class="search-list search-list-main scroll-area overflow-hidden"
        :class="{'show': showpane }"
        tagname="ul"
      >
        <div
          v-if="loader"
          class="spin-div"
        >
          <b-spinner
            small
            class="mr-1 spinner-inside"
            label="Small Spinner"
          />
        </div>
        <div
          v-if="emptyfilteredData"
        >
          <li
            class="suggestion-group-suggestion no-results"
          >
            <p>No Results Found.</p>
          </li>
        </div>
        <li
          v-for="(suggestion_list, grp_name, grp_index) in filteredData"
          :key="grp_index"
          class="suggestions-groups-list"
        >
          <div v-if=" suggestion_list.data.length > 0">
            <!-- Group Header -->
            <p class="suggestion-group-title">
              <span>
                {{ title(grp_name) }}
              </span>
            </p>
            <!-- Suggestion List of each group -->
            <ul>
              <li
                v-for="(suggestion, index) in suggestion_list.data"
                :id="'listitem_'+grp_index+'_'+index"
                :key="index"
                class="suggestion-group-suggestion cursor-pointer"
                :class="{'suggestion-current-selected': currentSelected === `${grp_index}.${index}`}"
                @mouseenter="currentSelected = `${grp_index}.${index}`"
                @mousedown.prevent="suggestionSelected(suggestion)"
              >
                <template v-if="grp_name === 'cases'">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      :icon="suggestion.icon"
                      size="25"
                      class="mr-75"
                    />
                    <div>
                      <p v-if="suggestion.matched_by === 'document'">
                        Case Found with base document:
                        <span
                            v-for="(part, i) in splitMatch(suggestion.documentTitle, searchQuery)"
                            :key="i"
                          >
                            <strong v-if="part.match">{{ part.text }}</strong>
                            <span v-else>{{ part.text }}</span>
                          </span>
                      </p>
                      <p>Base Type: <span
                        v-for="(part, i) in splitMatch(suggestion.baseTypeName, searchQuery)"
                        :key="i"
                      >
                        <strong v-if="part.match">{{ part.text }}</strong>
                        <span v-else>{{ part.text }}</span>
                      </span></p>
                      <div><small>Business Central Case Id:  <span
                        v-for="(part, i) in splitMatch(suggestion.bcCaseId ? suggestion.bcCaseId : 'N/A', searchQuery)"
                        :key="i"
                      >
                        <strong v-if="part.match">{{ part.text }}</strong>
                        <span v-else>{{ part.text }}</span>
                      </span></small></div>
                      <div><small>Case Id: <span
                        v-for="(part, i) in splitMatch(suggestion.caseId, searchQuery)"
                        :key="i"
                      >
                        <strong v-if="part.match">{{ part.text }}</strong>
                        <span v-else>{{ part.text }}</span>
                      </span></small></div>
                      <div><small>Case Group:  <span
                        v-for="(part, i) in splitMatch(suggestion.caseGroup ? suggestion.caseGroup : 'No Group', searchQuery)"
                        :key="i"
                      >
                        <strong v-if="part.match">{{ part.text }}</strong>
                        <span v-else>{{ part.text }}</span>
                      </span></small></div>
                      <div>
                        <small>
                          Client:
                          <span
                            v-for="(part, i) in splitMatch(suggestion.clientName, searchQuery)"
                            :key="i"
                          >
                            <strong v-if="part.match">{{ part.text }}</strong>
                            <span v-else>{{ part.text }}</span>
                          </span>
                        </small>
                      </div>
                      <div>
                        <small>
                          Debtors:
                          <span
                            v-for="(part, i) in splitMatch(suggestion.debtorNames, searchQuery)"
                            :key="i"
                          >
                            <strong v-if="part.match">{{ part.text }}</strong>
                            <span v-else>{{ part.text }}</span>
                          </span>
                        </small>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="grp_name === 'debtors'">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="UserIcon"
                      size="25"
                      class="mr-75"
                    />
                    <div>
                      <p>
                        <small>
                          <span
                            v-for="(part, i) in splitMatch(suggestion.name, searchQuery)"
                            :key="i"
                          >
                            <strong v-if="part.match">{{ part.text }}</strong>
                            <span v-else>{{ part.text }}</span>
                          </span>
                        </small>
                      </p>
                      <small><a :href="'mailto:' + suggestion.email">{{ suggestion.email }}</a></small>
                    </div>
                  </div>
                </template>
                <template v-else-if="grp_name === 'clients'">
                  <div class="d-flex align-items-center">
                    <feather-icon
                      icon="UserIcon"
                      size="25"
                      class="mr-75"
                    />
                    <div>
                      <p>
                        <span
                          v-for="(part, i) in splitMatch(suggestion.name, searchQuery)"
                          :key="i"
                        >
                          <strong v-if="part.match">{{ part.text }}</strong>
                          <span v-else>{{ part.text }}</span>
                        </span>
                      </p>
                      <small><a :href="'mailto:' + suggestion.email">{{ suggestion.email }}</a></small>
                    </div>
                  </div>
                </template>
                <b-link
                  v-if="grp_name === 'suggestions'"
                  class="p-0"
                >
                  <feather-icon
                    :icon="suggestion.icon"
                    class="mr-75"
                  />
                  <span class="align-middle">{{ suggestion.title }}</span>
                </b-link>
              </li>

              <li
                v-if="!(suggestion_list.data).length"
                class="suggestion-group-suggestion no-results"
              >
                <p>No Results Found.</p>
              </li>
            </ul>
          </div>
        </li>
      </vue-perfect-scrollbar>
    </div>
  </li>
</template>

<script>
import {
  BFormInput, BLink, BButton, BButtonGroup, BSpinner,
} from 'bootstrap-vue'
// import { ref, watch } from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import useAutoSuggest from '@core/components/app-auto-suggest/useAutoSuggest'
import { title } from '@core/utils/filter'
import router from '@/router'
import store from '@/store'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
// import searchAndBookmarkData from '../search-and-bookmark-data'

export default {
  components: {
    BFormInput,
    BLink,
    BButton,
    BButtonGroup,
    BSpinner,
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      emptyfilteredData: false,
      loader: false,
      searchQuery: '',
      currentSelected: '0.0',
      delayTime: null,
      showpane: false,
      showSearchBar: false,
      filteredData: {
        cases: { data: [] },
        clients: { data: [] },
        debtors: { data: [] },
        suggestions: { data: [] },
      },
      currentSuggestion: {},
      title,
    }
  },
  watch: {
    searchQuery: {
      handler(val) {
        const delay = 500
        if (this.delayTime) clearTimeout(this.delayTime)
        this.delayTime = setTimeout(() => {
          if (val.trim() !== '') {
            this.hitSearch()
          }
        }, delay)
      },
    },
  },
  methods: {
    async hitSearch() {
      this.emptyfilteredData = false
      if (this.searchQuery) {
        store.commit('app/TOGGLE_OVERLAY', Boolean(true))
        this.filteredData = {}
        this.showpane = true
        this.loader = true
        const searchData = await axios.get(`/search-records?searchQuery=${this.searchQuery}`)
        if (searchData.status) {
          document.getElementById('searchinput').focus()
          this.loader = false
          this.filteredData = searchData.data.data
          if (this.filteredData.cases.data.length === 0 && this.filteredData.debtors.data.length === 0 && this.filteredData.clients.data.length === 0 && this.filteredData.suggestions.data.length === 0) {
            this.emptyfilteredData = true
          }
          if (this.filteredData.cases.data.length > 0) {
            this.currentSelected = '0.0'
            // eslint-disable-next-line prefer-destructuring
            this.currentSuggestion = this.filteredData.cases.data[0]
          } else if (this.filteredData.clients.data.length > 0) {
            this.currentSelected = '1.0'
            // eslint-disable-next-line prefer-destructuring
            this.currentSuggestion = this.filteredData.clients.data[0]
          } else if (this.filteredData.debtors.data.length > 0) {
            this.currentSelected = '2.0'
            // eslint-disable-next-line prefer-destructuring
            this.currentSuggestion = this.filteredData.debtors.data[0]
          } else {
            this.currentSelected = '3.0'
            // eslint-disable-next-line prefer-destructuring
            this.currentSuggestion = this.filteredData.suggestions.data[0]
          }
        }
      } else {
        this.showpane = false
      }
    },
    suggestionSelected(suggestion) {
      this.showSearchBar = false
      this.resetsearchQuery()
      const currentroute = this.$route.name
      if (suggestion.route.name === 'nav-cases' && (currentroute === 'cases' || currentroute === 'nav-cases')) {
        const button = document.querySelector('#add-case-btn')
        button.click()
      } else {
        router.push(suggestion.route).catch(() => {})
        if (currentroute === suggestion.route.name) router.go()
      }
    },
    resetsearchQuery() {
      this.searchQuery = ''
      this.showpane = false
      this.filteredData = {}
      this.currentSelected = '0.0'
      store.commit('app/TOGGLE_OVERLAY', Boolean(false))
    },
    increaseIndex(val) {
      /* eslint-disable no-lonely-if, no-plusplus */
      // If there's no matching items
      if (!Object.values(this.filteredData).some(grpItems => (grpItems.data).length)) return
      const [grpIndex, itemIndex] = this.currentSelected.split('.')

      const grpArr = Object.entries(this.filteredData)
      const activeGrpTotalItems = (grpArr[grpIndex][1].data).length
      if (val) {
        // If active item is not of last item in grp
        if (activeGrpTotalItems - 1 > itemIndex) {
          this.currentSelected = `${grpIndex}.${Number(itemIndex) + 1}`

        // If active item grp is not last in grp list
        } else if (grpIndex < grpArr.length - 1) {
          for (let i = Number(grpIndex) + 1; i < grpArr.length; i++) {
            // If navigating group have items => Then move in that group
            if ((grpArr[i][1].data).length > 0) {
              this.currentSelected = `${Number(i)}.0`
              break
            }
          }
        }
      } else {
        // If active item is not of first item in grp
        if (Number(itemIndex)) {
          this.currentSelected = `${grpIndex}.${Number(itemIndex) - 1}`

        // If active item grp  is not first in grp list
        } else if (Number(grpIndex)) {
          for (let i = Number(grpIndex) - 1; i >= 0; i--) {
            // If navigating group have items => Then move in that group
            if ((grpArr[i][1].data).length > 0) {
              this.currentSelected = `${i}.${(grpArr[i][1].data).length - 1}`
              break
            }
          }
        }
      }
      // const ii = number(itemIndex)+1
      const [grpIndexSuggestion, itemIndexSuggestion] = this.currentSelected.split('.')
      this.currentSuggestion = grpArr[grpIndexSuggestion][1].data[itemIndexSuggestion]
      const div = document.getElementById(`listitem_${grpIndexSuggestion}_${itemIndexSuggestion}`)
      const rect = div.getBoundingClientRect()
      const ul = document.getElementById('listing-ul')
      const ulrect = ul.getBoundingClientRect()
      const x = rect.top
      // let w = rect.width
      const ulh = ulrect.height
      if (x > ulh) {
        ul.scrollBy(0, 70)
      }
      if (x < 0) {
        ul.scrollBy(0, -100)
      }
      /* eslint-enable no-lonely-if, no-plusplus */
    },
    splitMatch(text, query) {
      const textCheck = (text ?? '').toString()
      if (!query) return [{ text: textCheck, match: false }]
      const regex = new RegExp(`(${query})`, 'gi')
      return textCheck.split(regex).map(part => ({
        text: part,
        match: part.toLowerCase() === query.toLowerCase(),
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

ul
{
  list-style: none;
  padding: 0;
  margin: 0;
}
p {
  margin: 0;
}

/* .app-auto-suggest {
  position: relative;
}

.auto-suggest-suggestions-list {
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border-radius: 6px;
  position: absolute;
  top: calc(100% + 1rem);
  background-color: white;
  width: 100%;
} */

.suggestion-group-title {
  font-weight: 500;
  padding: .75rem 1rem .25rem;
}

.suggestion-group-suggestion {
  padding: .75rem 1rem
}

.suggestion-current-selected {
  background-color: $body-bg;

  .dark-layout & {
    background-color: $theme-dark-body-bg;
  }
}

.btn-groups {
  bottom: 5px;
}

.spin-div {
    text-align: center;
    padding: 15px 0px 15px 0px;
}

.spinner-inside {
    height: 25px;
    width: 25px;
}
</style>
